import React, { Component } from 'react';
import { toJS, reaction } from 'mobx';
import { PullRefresh, ProgressState, SearchBar } from '../../../../index';
import RefList from '../component/RefList';
import './RefPageView.less';
import tools from '../../../../utils/tools';
import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import stores from '../../../stores';
const { queryStore } = stores;


@observer
class RefPageView extends Component {

  constructor(props) {
    super(props);
    if (queryStore.refModel) {
      queryStore.refModel.load(this.props.refParams);
    }
  }



  clearSelecteds = () => {
    this.clear();
    this.ok();
  }

  clear = (e) => {
    tools.preventEvent(e);
    queryStore.refModel.clearSelect();
  }

  ok = (e) => {
    tools.preventEvent(e);
    const {
      code,
      mode,
      chose
    } = this.props.refParams;
    this.props.callBack('ok', {
      type: 'refOK',
      code,
      mode,
      chose,
      refObject: queryStore.refModel.refObject,
      selecteds: toJS(queryStore.refModel.selecteds)
    });
  }

  goBack = () => {
    this.context.pop();
  }

  clearError = () => {
    queryStore.refModel.clearError();
    this.context.pop();
  }

  handleLoadMore = (afterMore) => {
    queryStore.refModel.loadNext(queryStore.refModel.searchValue).then(() => {
      afterMore && afterMore(queryStore.refModel.displayData.length);
    });
  }

  handleChange = (value) => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(() => {
      this.timer = null;
      queryStore.refModel.loadNext(value);
    }, 1000);
  }

  handleSelect = (value) => {
    if(queryStore.refModel.type=='textcombobox' && !value.Name){
      value = {ID:value.Value,Code:value.Value,Name:value.Value};
    }
    queryStore.refModel.select(value);
    if (!queryStore.refModel.multiSelect) {
      this.ok();
    }
  }

  itemRender = (rowData, sectionID, rowID) => {
    return <RefList
      rowID={rowID}
      localSearch={queryStore.refModel.localSearch}
      searchValue={queryStore.refModel.searchValue}
      items={[queryStore.refModel.displayData[rowID]]}
      isMultiSelect={queryStore.refModel.multiSelect}
      onSelected={this.handleSelect}
      selecteds={toJS(queryStore.refModel.selecteds)} />
  };

  genData(dataSize) {
    const selecteds = queryStore.refModel.selecteds.map(item => {
      return item.ID;
    });

    const dataArr = [];
    for (let i = 0; i < dataSize; i++) {
      const item = queryStore.refModel.displayData[i];
      dataArr.push(`row - ${item.value.ID || item.value.Id || item.value.Value} - selected - ${item.selected}`);
    }
    return dataArr;
  }

  onFocus = () => {
    this.props.searchBarFocus();
    // setTimeout(() => {

    //   this.refPage.scrollTo(0, 0);
    // }, 1000)
  }

  render() {
    const selecteds = queryStore.refModel.selecteds;
    queryStore.refModel.displayData.forEach(item => {
      item.selected = false;
      if (queryStore.refModel.indexOf(selecteds, item.value) > -1) {
        item.selected = true;
      }
    });
    return (
      <div className='refPage' ref={refPage => this.refPage = refPage}>
        <div className='button-group'>
          <div className='close' onClick={this.props.close}>取消</div>
          {
            true == queryStore.refModel.multiSelect && <div className='sure' onClick={this.ok}>保存</div>
          }
          <div className='clear' onClick={this.clearSelecteds}>清空</div>
          
        </div>
        <SearchBar onChange={this.handleChange} realInput={this.props.fullScreen} onFocus={this.onFocus} placeholder={'搜索' + (queryStore.refModel.refTitle || '') + '名称'}> </SearchBar>
        <div className='separator'></div>
        <ProgressState
          state={queryStore.refModel.loaded ? (queryStore.refModel.displayData.length > 0 ? 'show' : 'empty') : 'load'}
          empty={{ info: '亲，还没有相关的数据哦~' }}
          error={{ info: '哎呀, 发生错误了~' }}>
          <div className='body'>
            <PullRefresh
              dataSize={queryStore.refModel.displayData.length}
              useBodyScroll={false}
              onMore={queryStore.refModel.hasMore ? this.handleLoadMore : undefined}
              itemRender={this.itemRender}
              genData={this.genData}
              separatorStyle={{}}
              footerStyle={{ height: '1.2rem' }} />
          </div>
        </ProgressState>
        {/* {true == queryStore.refModel.multiSelect && <div className='footer'><div className='cancel' onClick={this.clear}>重置</div><div className='ok' onClick={this.ok}>确定</div></div>} */}
      </div>
    )
  }
}

RefPageView.contextTypes = {
  pop: PropTypes.func,
  push: PropTypes.func,
  pushForResult: PropTypes.func,
  pageParam: PropTypes.func,
  popAndReturn: PropTypes.func,
  replace: PropTypes.func
}

export default RefPageView;
